const data = [
    {
      id: 1,
      name: 'Veronica Smigielski',
      age: 25,
      image:
        'https://s3.amazonaws.com/shecodesio-production/students/avatars/000/021/689/medium/Profile_picture.png?1612225148',
    },
    {
      id: 2,
      name: 'Giovanni Peeters',
      age: 26,
      image:
        'images/Gio.jpg',
    },
    {
      id: 3,
      name: 'Corwin Heirman',
      age: 25,
      image:
        'images/Corwin.jpg',
    },
    {
      id: 4,
      name: 'Alyssa Irwin',
      age: 24,
      image:
        'images/Alyssa.jpg',
    },
    {
      id: 5,
      name: 'Hana Furst',
      age: 61,
      image:
        'images/Hana.jpg',
    },
  ];

  export default data;